import { OrderStatusEnum } from '@onArte/shared/enums';
import {
  OrderAuctionDetailsDTO,
  OrderBaseDetailsDTO,
  OrderPaymentDetailsDTO,
  PromotionCodeInterface,
  UserSimpleDTO
} from '@onArte/shared/interfaces/common';

export class OrderDetailsDTO extends OrderBaseDetailsDTO {
  constructor(
    id: string,
    no: string,
    buyer: UserSimpleDTO,
    auctions: OrderAuctionDetailsDTO[],
    promotionsCodes: PromotionCodeInterface[],
    orderedAt: number,
    status: OrderStatusEnum,
    payment: OrderPaymentDetailsDTO,
    public basePrice: number,
    public finalPrice: number,
    commentToOrder: string | null,
  ) {
    super(id, no, buyer, auctions, promotionsCodes, orderedAt, status, payment, commentToOrder);
  }
}
